import React from 'react'
import {  Modal, ModalBody } from 'reactstrap'

export default function AreYouSureModal({openModal,closeModal,handleSubmit}) {

  return (
    <>
      <Modal isOpen={openModal} backdrop="static" toggle = {closeModal}>
        <ModalBody>
          <div className="modal-content rounded-20 border-0">
            <div className="modal-body pb-0">
              <div className="text-center mb-10">
                <img
                  src="/assets/images/add_emp.png"
                  alt="are you sure"
                />
              </div>
              <h5 className="modal-title text-center">
                Are you sure you would like to submit?
              </h5>
            </div>
            <div className="modal-footer claim-modal">
              <button
                onClick={handleSubmit}
                type="button"
                className="btn btn-primary pl-10 pr-10"
                data-dismiss="modal"
              >
                Yes
              </button>{' '}
              <button
                onClick={closeModal}
                type="button text-dark"
                className="btn no-btn pl-10 pr-10"
                data-dismiss="modal"
              >
                No
              </button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </>
  )
}
